import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import { hexToRgba } from '@mrkt/features/color-conversion';
import { gold155, gray7, gray10, kleinBlue61, white, black, opacityBlack90, pink100, gray50, gray70, opacityBlack70, cssColorValue } from '@spotify-internal/encore-web';
var darkComponents = {
  app: 'dark',
  table: 'dark',
  tableRow: 'dark',
  buttonIcon: 'dark',
  loadingIndicator: 'dark',
  navBar: 'dark',
  navBarList: 'dark',
  navBarListItem: 'dark',
  dialogAlert: 'dark',
  dialogConfirmation: 'dark',
  formGroup: 'dark',
  // formInput: 'dark',
  button: 'dark'
};
var help = {
  link: {
    hover: gray70,
    divider: cssColorValue('backgroundPress')
  },
  grayBox: {
    background: cssColorValue('decorativeSubdued'),
    text: black
  },
  banner: {
    background: kleinBlue61,
    text: white,
    ctaText: black
  },
  sideMenu: {
    currentCategoryIndicator: pink100,
    unselectedCategory: gray70,
    selectedCategory: black,
    text: black,
    background: cssColorValue('backgroundHighlight')
  }
};
var searchBar = {
  background: white,
  border: gray70,
  suggestionHeader: opacityBlack70,
  icon: gray70
}; // dark theme is the default
// everything required should be specified here

export var defaultTheme = _objectSpread(_objectSpread({}, darkComponents), {}, {
  app: 'dark',
  loadingIndicator: 'dark',
  box: {
    background: gray10,
    text: white,
    tileOneBackground: gray10,
    tileTwoBackground: black
  },
  cta: {
    background: white,
    text: gray7
  },
  label: {
    text: gray10
  },
  banner: {
    background: white,
    text: gray10
  },
  layout: {
    background: opacityBlack90,
    text: white
  },
  nav: {
    background: black,
    text: white,
    sideMenuBackground: black,
    sideMenuTextColor: white
  },
  link: {
    color: white,
    hover: gray50,
    tap: hexToRgba(black, 0.3)
  },
  help: help,
  searchBar: searchBar
});
export var darkTheme = defaultTheme;
/* light theme only applies to the current page area, not the navigation, etc */

export var lightTheme = _objectSpread(_objectSpread({}, defaultTheme), {}, {
  loadingIndicator: 'light',
  dialogAlert: 'light',
  cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
    background: black,
    text: white
  }),
  box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
    background: white,
    text: black
  }),
  banner: {
    background: gray10,
    text: white
  },
  link: _objectSpread(_objectSpread({}, defaultTheme.link), {}, {
    color: black
  })
});
export var TEMPLATE_THEMES = {
  Dark: darkTheme,
  Light: lightTheme
}; // module themes get merged with the template theme

export var MODULE_THEMES = {
  whiteOnBlue: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: kleinBlue61,
      text: white
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: white,
      text: kleinBlue61
    })
  },
  blueOnWhite: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: white,
      text: kleinBlue61
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: kleinBlue61,
      text: white
    })
  },
  blueOnBlack: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: gray10,
      text: kleinBlue61
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: kleinBlue61,
      text: gray10
    })
  },
  blackOnWhite: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: white,
      text: gray10,
      tileOneBackground: cssColorValue('backgroundHighlight'),
      tileTwoBackground: cssColorValue('decorativeSubdued')
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: gray10,
      text: cssColorValue('decorativeSubdued')
    }),
    link: _objectSpread(_objectSpread({}, defaultTheme.link), {}, {
      color: gray10
    })
  },
  blackOnGold: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: gold155,
      text: gray10
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: gray10,
      text: gold155
    })
  },
  goldOnBlack: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: gray10,
      text: gold155
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: gold155,
      text: gray10
    })
  },
  whiteOnBlack: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: gray10,
      text: white,
      tileOneBackground: gray10,
      tileTwoBackground: black
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: white,
      text: gray7
    }),
    link: _objectSpread(_objectSpread({}, defaultTheme.link), {}, {
      color: white
    })
  },
  blackOnGray: {
    box: _objectSpread(_objectSpread({}, defaultTheme.box), {}, {
      background: cssColorValue('decorativeSubdued'),
      text: gray10
    }),
    cta: _objectSpread(_objectSpread({}, defaultTheme.cta), {}, {
      background: white,
      text: gray7
    })
  }
};